import React from "react";
import PropTypes from "prop-types";

import { useBreakpoint } from "../WidgetBreakpoint";
import { useTranslation } from "react-i18next";

import { XAxis, YAxis, FlexibleXYPlot, VerticalRectSeries } from "react-vis";
import "react-vis/dist/style.css";

import { Colours } from "@learningblocks/shared-components";

// const FlexibleXYPlot = makeWidthFlexible(XYPlot);

export default function BarChart3(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const breakpoints = useBreakpoint();

  const data = props.widgetData.Histogram3;

  const barXYData = (isRounded, requirement) => {
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min;

    const bins = props.bins;
    let binWidth = range / bins;

    const roundedBinWidth = (Math.floor(binWidth * 4) / 4 + 0.25).toFixed(2);

    if (isRounded === true) {
      binWidth = roundedBinWidth;
    }

    const Ys = [];
    const cols = [];
    for (let i = 1; i < bins + 1; i++) {
      const col = {
        x: min + binWidth * i - 0.02,
        y: 0,
        x0: min + binWidth * (i - 1) + 0.02,
        y0: 0,
      };

      // if(i === 1 && isRounded === true){col.x0 = col.x0 - 0.25}
      // if(i === bins && isRounded === true){col.x = col.x + 0.25}

      data.map((val) => {
        if (min + binWidth * (i - 1) <= val && val <= min + binWidth * i) {
          col.y++;
        }
      });
      Ys.push(col.y);
      // if(col.x0 < max){
      cols.push(col);
      // }
    }

    if (requirement === "aria-label") {
      const modesXs = [];
      const maxFrequency = Math.max(...Ys);
      let modeQuantity = 0;
      cols.map((col) => {
        if (col.y === maxFrequency) {
          modeQuantity++;
          modesXs.push({
            xStart: col.x0,
            xEnd: col.x,
          });
        }
      });
      let string = "";
      modesXs.map((mode, index) => {
        if (index === 0) {
          string =
            string +
            t(`{{start_min}} meters to {{start_max}} meters`, {
              start_min: Math.round(mode.xStart * 10) / 10,
              start_max: Math.round(mode.xEnd * 10) / 10,
            });
        } else {
          string =
            string +
            " " +
            t(`and from {{end_min}} meters to {{end_max}} meters`, {
              end_min: Math.round(mode.xStart * 10) / 10,
              end_max: Math.round(mode.xEnd * 10) / 10,
            });
        }
      });

      const ariaLabel = `${t("Summary description graph {{number}}:", { number: isRounded ? "2" : "1" })} ${t("This histogram {{rounded}} and has {{bins}} {{plural}}.", { rounded: isRounded ? "is rounded" : "is not rounded", bins: props.bins, plural: props.bins > 1 ? "bins" : "bin" })} ${t("There {{plural}} {{modeQuantity}} {{pluralMode}}.", { plural: modeQuantity > 1 ? "are" : "is", modeQuantity: modeQuantity, pluralMode: modeQuantity > 1 ? "modes" : "mode" })}" ${t(`With a frequency of {{maxFrequency}} from {{string}}`, { maxFrequency: maxFrequency, string: string })}`;
      return ariaLabel;
    }

    if (requirement === "table") {
      return (
        <table style={{ width: props.width }}>
          <tbody>
            <tr>
              <th
                style={{
                  padding: "8px",
                  textAlign: "left",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                {t("Bins")}
              </th>
              <th
                style={{
                  padding: "8px",
                  textAlign: "left",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                {t("Counts")}
              </th>
            </tr>
            {cols.map((col, index) => {
              return (
                <tr key={index}>
                  <td
                    style={{
                      padding: "8px",
                      textAlign: "left",
                      color: "white",
                      backgroundColor: index % 2 === 0 ? "rgb(0,62,107)" : null,
                    }}
                  >
                    {t(`{{start_m}} meters to {{end_m}} meters`, {
                      start_m: Math.round(col.x0 * 10) / 10,
                      end_m: Math.round(col.x * 10) / 10,
                    })}
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      color: "white",
                      backgroundColor: index % 2 === 0 ? "rgb(0,62,107)" : null,
                      textAlign: "center",
                    }}
                  >
                    {col.y}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      );
    }

    return cols;
  };

  return (
    <div
      style={{
        background: "#002F52",
        border: "1px solid " + Colours.navy4,
        boxSizing: "border-box",
        borderRadius: "5px",
        padding: "5px 20px",
        paddingTop: "60px",
        position: "relative",
      }}
    >
      <button
        style={{
          cursor: "pointer",
          border: "none",
          minWidth: "130px",
          height: "38px",
          borderRadius: "5px",
          backgroundColor: "white",
          color: "black",
          position: "absolute",
          top: "15px",
          right: "15px",
          fontSize: "14px",
        }}
        onClick={() => {
          if (props.display === "table") {
            props.setDisplay("histogram");
          } else {
            props.setDisplay("table");
          }
        }}
        aria-label={t(
          `Toggle the representation of the data to a ${props.display === "table" ? "histogram" : "table"}`
        )}
      >
        {t(`View as ${props.display === "table" ? "histogram" : "table"}`)}
      </button>
      <div
        className="bar-chart"
        style={
          breakpoints.sm
            ? { paddingBottom: "100px" }
            : { paddingBottom: "40px" }
        }
      >
        <div
          ariaLabel={barXYData(false, "aria-label")}
          style={{ height: "0px", overflow: "hidden", width: "0px" }}
        >
          {barXYData(false, "aria-label")}
        </div>
        {props.display === "table" ? (
          <div>{barXYData(false, "table")}</div>
        ) : null}
        {props.display === "histogram" ? (
          <>
            <FlexibleXYPlot
              animation
              yDomain={[0, 20]}
              xDomain={[0, 6]}
              width={props.width}
              height={props.height}
            >
              <VerticalRectSeries
                color={Colours.yellow1}
                data={barXYData(false)}
              />
              <XAxis
                tickValues={[0, 1, 2, 3, 4, 5, 6]}
                tickFormat={(v) => Math.trunc(v)}
                style={{ text: { fill: "white" } }}
              />
              <YAxis
                tickValues={[0, 5, 10, 15, 20]}
                tickFormat={(v) => Math.trunc(v)}
                style={{ text: { fill: "white" } }}
              />
              <div
                style={{
                  width: "calc(100% - 40px)",
                  height: "100%",
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                }}
              >
                <div
                  style={{
                    width: "2px",
                    borderLeft: "2px dashed white",
                    opacity: 0.5,
                    height: "80%",
                    position: "absolute",
                    bottom: "40px",
                    left: 6 * ((props.width - 40) / 12) - 6,
                  }}
                ></div>
              </div>
              <p
                style={{
                  position: "absolute",
                  left: "-25px",
                  bottom: "calc(50% - 10px)",
                  color: "white",
                  fontSize: "14px",
                  transform: "rotate(-90deg)",
                  textAnchor: "middle",
                  width: "fit-content",
                }}
              >
                {t("Counts")}
              </p>
              <p
                style={{
                  position: "absolute",
                  left: "-10px",
                  bottom: breakpoints.sm ? "-100px" : "-50px",
                  color: "white",
                  fontSize: "14px",
                  textAnchor: "middle",
                  width: "100%",
                  padding: "10px",
                }}
              >
                {barXYData(false).map((col, key) => {
                  if (key === 0) {
                    return `${t("Bins")}: ${(col.x0 - 0.02).toFixed(2)}, ${(Number(col.x) + 0.02).toFixed(2)}`;
                  } else {
                    return `, ${(Number(col.x) + 0.02).toFixed(2)}`;
                  }
                })}
              </p>
            </FlexibleXYPlot>
          </>
        ) : null}
      </div>
      <div
        className="bar-chart"
        style={
          breakpoints.sm
            ? { paddingBottom: "100px" }
            : { paddingBottom: "40px" }
        }
      >
        <div
          ariaLabel={barXYData(true, "aria-label")}
          style={{ height: "0px", overflow: "hidden", width: "0px" }}
        >
          {barXYData(true, "aria-label")}
        </div>
        {props.display === "table" ? (
          <div>{barXYData(true, "table")}</div>
        ) : null}
        {props.display === "histogram" ? (
          <>
            <FlexibleXYPlot
              animation
              yDomain={[0, 20]}
              xDomain={[0, 6]}
              width={props.width}
              height={props.height}
            >
              <VerticalRectSeries
                color={Colours.yellow1}
                data={barXYData(true)}
              />
              <XAxis
                tickValues={[0, 1, 2, 3, 4, 5, 6]}
                tickFormat={(v) => Math.trunc(v)}
                style={{ text: { fill: "white" } }}
              />
              <YAxis
                tickValues={[0, 5, 10, 15, 20]}
                tickFormat={(v) => Math.trunc(v)}
                style={{ text: { fill: "white" } }}
              />
              <div
                style={{
                  width: "calc(100% - 40px)",
                  height: "100%",
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                }}
              >
                <div
                  style={{
                    width: "2px",
                    borderLeft: "2px dashed white",
                    opacity: 0.5,
                    height: "80%",
                    position: "absolute",
                    bottom: "40px",
                    left: 6 * ((props.width - 40) / 12) - 6,
                  }}
                ></div>
              </div>
              <p
                style={{
                  position: "absolute",
                  left: "-25px",
                  bottom: "calc(50% - 10px)",
                  color: "white",
                  fontSize: "14px",
                  transform: "rotate(-90deg)",
                  textAnchor: "middle",
                  width: "fit-content",
                }}
              >
                {t("Counts")}
              </p>
              <p
                style={{
                  position: "absolute",
                  left: "-10px",
                  bottom: breakpoints.sm ? "-100px" : "-50px",
                  color: "white",
                  fontSize: "14px",
                  textAnchor: "middle",
                  width: "100%",
                  padding: "10px",
                }}
              >
                {barXYData(true).map((col, key) => {
                  if (key === 0) {
                    return `${t("Bins")}: ${(col.x0 - 0.02).toFixed(2)}, ${(Number(col.x) + 0.02).toFixed(2)}`;
                  } else {
                    return `, ${(Number(col.x) + 0.02).toFixed(2)}`;
                  }
                })}
              </p>
            </FlexibleXYPlot>
          </>
        ) : null}
      </div>
    </div>
  );
}

BarChart3.propTypes = {
  width: PropTypes.int,
  height: PropTypes.int,
  type: PropTypes.string,
  visible: PropTypes.boolean,
  hist: PropTypes.string,
};
